import { DateTime } from 'luxon';

/**
 * Formats an ISO date string to UTC and returns it in 'dd/MM/yyyy' format.
 *
 * @param dateString - The ISO date string to format. If null or undefined, returns an empty string.
 * @returns The formatted date string in 'dd/MM/yyyy' format, or an empty string if input is invalid.
 */
export const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) {
    return '';
  }

  // Check if date string has timezone information
  // ISO dates should only have 'Z' suffix (UTC timezone)
  // Dates with timezone offset like '+00:00' or without timezone are considered invalid
  const hasValidTimezone = dateString.includes('Z');

  if (!hasValidTimezone) {
    console.error('Date string without proper UTC timezone (Z) detected:', dateString);
  }

  return DateTime.fromISO(dateString).toUTC().toFormat('dd/LL/yyyy');
};

/**
 * Formats an ISO date string to UTC and returns it in 'HH:mm dd/MM/yyyy' format.
 *
 * @param dateString - The ISO date string to format. If null or undefined, returns an empty string.
 * @returns The formatted date-time string in 'HH:mm dd/MM/yyyy' format, or an empty string if input is invalid.
 */
export const formatDateTime = (dateString: string | null | undefined) => {
  if (!dateString) {
    return '';
  }

  const hasValidTimezone = dateString.includes('Z');

  if (!hasValidTimezone) {
    console.error('Date string without proper UTC timezone (Z) detected:', dateString);
  }

  return DateTime.fromISO(dateString).toUTC().toFormat('HH:mm dd/LL/yyyy');
};
